import { useState } from 'react';
import { DEPENDENCY_CONSTANTS } from './types';

interface DependencyLineProps {
  path: string;
  sourceItemId: number;
  targetItemId: number;
  isHighlighted?: boolean;
}

export function DependencyLine({
  path,
  sourceItemId,
  targetItemId,
  isHighlighted = false,
}: DependencyLineProps) {
  const [isHovered, setIsHovered] = useState(false);

  const strokeWidth =
    isHovered || isHighlighted
      ? DEPENDENCY_CONSTANTS.LINE_HOVER_STROKE_WIDTH
      : DEPENDENCY_CONSTANTS.LINE_STROKE_WIDTH;

  const strokeColor = isHovered || isHighlighted ? '#dcfce7' : '#9ca3af'; // green-100 : gray-400

  return (
    // biome-ignore lint/a11y/noStaticElementInteractions: Hover effects are for visual feedback only
    <g
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label={`Dependency from item ${sourceItemId} to item ${targetItemId}`}
      style={{ cursor: 'pointer' }}
    >
      <path
        d={path}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        fill="none"
        markerEnd="url(#arrowhead)"
        className="transition-all duration-0"
        style={{ pointerEvents: 'stroke', color: strokeColor }}
        data-source-id={sourceItemId}
        data-target-id={targetItemId}
      >
        <title>
          Dependency: Item {sourceItemId} → Item {targetItemId}
        </title>
      </path>
    </g>
  );
}
